import spinner from '../assets/spinner.gif'
export const Loader = () => {
  return (
    <>
    <img alt='spinner' src={spinner} style={{ width: '110px'}} />
    </>
  )
}
